(function (window) {
  'use strict';

  function patchJQueryLegacy($) {
    if (!$ || $.__legacyShimApplied) return $;

    if (typeof $.trim !== 'function') {
      $.trim = function (text) {
        return text == null ? '' : String(text).trim();
      };
    }

    if (!$.camelCase) {
      $.camelCase = function (string) {
        return String(string).replace(/-([a-z])/ig, function (_all, letter) {
          return letter.toUpperCase();
        });
      };
    }

    if (!$.type) {
      $.type = function (obj) {
        if (obj == null) return String(obj);
        return typeof obj === 'object' || typeof obj === 'function'
          ? Object.prototype.toString.call(obj).slice(8, -1).toLowerCase()
          : typeof obj;
      };
    }

    if (!$.isFunction) {
      $.isFunction = function (obj) {
        return typeof obj === 'function';
      };
    }

    if (!$.isNumeric) {
      $.isNumeric = function (obj) {
        const value = parseFloat(obj);
        return !Number.isNaN(value) && Number.isFinite(value);
      };
    }

    $.__legacyShimApplied = true;
    return $;
  }

  function installAssignmentHook() {
    if (window.__jQueryLegacyHookInstalled) return;
    window.__jQueryLegacyHookInstalled = true;

    patchJQueryLegacy(window.jQuery);

    let currentJq = window.jQuery;

    try {
      Object.defineProperty(window, 'jQuery', {
        configurable: true,
        enumerable: true,
        get: function () {
          return currentJq;
        },
        set: function (value) {
          currentJq = patchJQueryLegacy(value);
        },
      });

      Object.defineProperty(window, '$', {
        configurable: true,
        enumerable: true,
        get: function () {
          return currentJq;
        },
        set: function (value) {
          currentJq = patchJQueryLegacy(value);
        },
      });
    } catch (_error) {
      const timer = window.setInterval(function () {
        patchJQueryLegacy(window.jQuery);
      }, 0);

      window.addEventListener('load', function () {
        window.clearInterval(timer);
        patchJQueryLegacy(window.jQuery);
      });
    }
  }

  installAssignmentHook();
  patchJQueryLegacy(window.jQuery);
})(window);
